import React from 'react';
import { NiceFormFieldSet } from './Components.styles';
import TextInput from './TextInput';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';
import { ApIcon, colors } from '@alixpartners/ui-components';

const RadioInput = ({
	handleChange,
	options,
	selectedValue,
	legendText,
	name,
	instructions,
}) => {
	return (
		<NiceFormFieldSet>
			<legend>
				{legendText}
				{instructions && (
					<Tooltip
						position="bottom"
						animation="fade"
						arrow
						html={<TooltipContent>{instructions}</TooltipContent>}
						trigger="mouseenter"
						style={{ position: 'relative', top: '5px', marginLeft: '2px' }}
					>
						<ApIcon
							iconName="info"
							iconSize="22px"
							outlined={true}
							iconColor={colors.green300}
						/>
					</Tooltip>
				)}
			</legend>
			{options.map(({ id, label }) => {
				let uniqueId = name + id;
				return (
					<div key={uniqueId}>
						<input
							type="radio"
							name={name} // Use the name prop
							id={uniqueId}
							onChange={handleChange}
							value={label}
							checked={selectedValue?.[0] === label}
						/>
						<label htmlFor={uniqueId}>{label}</label>
					</div>
				);
			})}
			{selectedValue?.[0] === 'Other' && (
				<TextInput
					placeholder="Type here"
					onChange={handleChange}
					name={name}
					value={selectedValue[1]}
					required
				/>
			)}
		</NiceFormFieldSet>
	);
};

export default RadioInput;
